import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/featured_sellers/inspired_looks'

const CmsFeaturesSellersInspiredLooksApiV2 = {

  /**
   * Edit a Cms for Featured Seller Inspired Look
   * Invoke `PATCH api/v2/admins/cms/featured_sellers/inspired_looks/:url'
   * @param {string} url - FS url-key
   * @param {object} payload - Payload data to be send to backend
   */
  update: async (url, payload) => {
    const path = `${API_PATH}/${url}`

    const response = await axios.patch(path, payload)

    return response
  }

}

export default CmsFeaturesSellersInspiredLooksApiV2
